import { render, staticRenderFns } from "./WideAppendixData.vue?vue&type=template&id=28e23aa3&scoped=true&"
import script from "./WideAppendixData.vue?vue&type=script&lang=js&"
export * from "./WideAppendixData.vue?vue&type=script&lang=js&"
import style0 from "./WideAppendixData.vue?vue&type=style&index=0&id=28e23aa3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e23aa3",
  null
  
)

export default component.exports